/**
 * AssetsToolbar — Overview top bar: Origin filter Select (All Assets / New Assets)
 * + Search Asset input + Create New Asset button.
 *
 * The Select filters by ORIGIN, not industry (asset-domain-v2-design.md §2.2) —
 * options come from ORIGIN_FILTERS (config-driven, extensible).
 */
import { Button, Input, Select, type SelectProps } from '@amzn/awsui-components-react';
import { ORIGIN_FILTERS } from '../utils/originFilters';

interface Props {
  originId: string;
  onOriginChange: (id: string) => void;
  search: string;
  onSearchChange: (v: string) => void;
  onCreate: () => void;
}

const ORIGIN_OPTIONS: SelectProps.Option[] = ORIGIN_FILTERS.map((o) => ({ value: o.id, label: o.label }));

export default function AssetsToolbar({ originId, onOriginChange, search, onSearchChange, onCreate }: Props) {
  const selected = ORIGIN_OPTIONS.find((o) => o.value === originId) ?? ORIGIN_OPTIONS[0];
  return (
    <div className="ivt-assets-toolbar">
      <div className="ivt-assets-toolbar__origin">
        <Select
          selectedOption={selected}
          onChange={({ detail }) => onOriginChange(detail.selectedOption.value ?? 'all')}
          options={ORIGIN_OPTIONS}
          ariaLabel="按 origin 筛选 Assets"
        />
      </div>
      <div className="ivt-assets-toolbar__search">
        <Input
          type="search"
          value={search}
          onChange={({ detail }) => onSearchChange(detail.value)}
          placeholder="Search Asset"
          ariaLabel="Search Asset"
        />
      </div>
      <Button variant="primary" onClick={onCreate}>
        Create New Asset
      </Button>
    </div>
  );
}
